module.exports = __webpack_public_path__ + "static/media/vouchers.14552768.svg";